import { Pipe, PipeTransform } from '@angular/core';
import { ObjectTitleService } from '../fi-services/object-title.service';

@Pipe({
    name: 'titleEdit',
    standalone: false,
})
export class TitleEditPipe implements PipeTransform {
    constructor(private objectTitleService: ObjectTitleService) {}

    transform(value: any, args?: any): any {
        return this.objectTitleService.getEditTitle(value);
    }
}
